export default "__VITE_ASSET__BZ1iDGY4__"